module.exports = __webpack_public_path__ + "img/farmacia-popup.1720b77f.jpg";